import {zodResolver} from '@hookform/resolvers/zod'
import {signupField, signupFieldValidation} from 'constants/FormField/signupField'
import useResponsive from 'logic/useResponsive'
import {useForm} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import {useParams, useNavigate} from 'react-router-dom'
import {toast} from 'sonner'
import {useSignupWithInviteMutation} from 'store/Store'

const useSignup = ({i18nCategory}) => {
    const {mediumScreen} = useResponsive()
    const navigate = useNavigate()
    const methods = useForm({
        resolver: zodResolver(signupFieldValidation),
    })

    const {token} = useParams()

    const {handleSubmit} = methods
    const {t} = useTranslation()

    const [doSignup, {error}] = useSignupWithInviteMutation()
    const onSubmit = (data) => {
        toast.promise(
            doSignup({token, data})
                .unwrap()
                .then(() => {
                    navigate('/login')
                })
                .catch((error) => {
                    console.log('toast error', error)
                    throw error
                }),
            {
                loading: t('loading'),
                success: () => t(`${i18nCategory}.success`),
                error: () => t(`${i18nCategory}.error`),
            }
        )
    }

    return {
        handleSubmit,
        onSubmit,
        error,
        mediumScreen,
        methods,
        t,
        formField: signupField,
    }
}

export default useSignup
